export default __webpack_public_path__ + "static/media/i (31).159fe40a.jpg";